import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { MunicipioXDepartamentoDTO } from '../../models/municipios-por-departamento/municipios-por-departamento';

@Injectable({
  providedIn: 'root',
})
export class MunicipiosPorDepartamentoService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.MUNICIPIOS_POR_DEPARTAMENTO}`;

  constructor(private http: HttpClient) {}

  getMunicipiosPorDepartamento(
    prm_departamento: string,
  ): Observable<MunicipioXDepartamentoDTO[]> {
    const body = {
      jsonParametros: JSON.stringify({ prm_departamento }),
    };

    return this.http.post<MunicipioXDepartamentoDTO[]>(this.apiUrl, body);
  }
}
